import script from "./TopNavbarGame.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavbarGame.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavbarGame.vue?vue&type=style&index=0&id=f92f04d0&scopped=true&lang=scss"

const __exports__ = script;

export default __exports__